import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../../../redux/store';
import BulkUploadIcon from '../../../Icons/BulkUploadIcon';
import ChevronRightIcon from '../../../Icons/ChevronRightIcon';
import LighteningIcon from '../../../Icons/LighteningIcon';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';

interface SelectKindOfPaymentProps {
  setModalTitle: (...args: any) => void;
}

const SelectKindOfPayment: React.FC<SelectKindOfPaymentProps> = ({
  setModalTitle,
}) => {
  const { lookupConfig } = useAppSelector((state) => state.lookupConfigData);
  const { setSliderIndexPos } = useContext(TranslatingContainerContext)!;
  const handleSingleLookUpClick = () => {
    setSliderIndexPos(1);
    setModalTitle('Single Look-up');
  };

  const handleBundleLookUpClick = () => {
    setSliderIndexPos(1);
    setModalTitle('Bundle Look-ups');
  };

  return (
    <Container>
      <Cell onClick={() => handleSingleLookUpClick()}>
        <LighteningIcon />
        <TextArea>
          <BoldText>Single Look-up</BoldText>
          <LightText>
            Buy 1 look-up instantly — {`₦${lookupConfig?.unitPrice ?? 0}`}
          </LightText>
        </TextArea>
        <ChevronRightIcon />
      </Cell>

      <Cell onClick={() => handleBundleLookUpClick()}>
        <BulkUploadIcon />
        <TextArea>
          <BoldText>Bundle Look-ups</BoldText>
          <LightText>Get discounted bundles of 20 - 40 look-ups</LightText>
        </TextArea>
        <ChevronRightIcon />
      </Cell>
    </Container>
  );
};

export default SelectKindOfPayment;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Cell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  cursor: pointer;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-right: auto;
`;

const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const LightText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: ${({ theme }) => theme.palette.neutralGray};
`;
